// extracted by mini-css-extract-plugin
export default {"wrapper":"TreeDetailPage_wrapper__Tx1JR"};